import React from "react";
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import CaregiverAddForm from "./CaregiverAddForm";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));


const CaregiverAdd = (props) => {

  const {className, history, ...rest } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <CaregiverAddForm history={history} />
      </div>
    </div>
  );
};

CaregiverAdd.propTypes = {
  history: PropTypes.object
};

export default CaregiverAdd;
